import React from 'react';
import PropTypes from "prop-types";
// import { convertDate } from '../../../../helpers/prismicHelpers/PrismicHelpers';
import { dateConverter } from '../../../../helpers/dateHelpers';
import Anchor from '../../../dashboardNew/objects/Anchor';

export const LastArticleSmall = props => {

    const {
        uid,
        title,
        small_img,
        date,
        languagePrismic
    } = props;

    const date_by_origin = dateConverter(date, 'LLLL');
    // const date_by_origin = convertDate(languagePrismic.lang, date);


    return (
        <Anchor path={`/blog/${uid}`} anchorClass="col-12 col-md-4" internal>
            <div style={{
                backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(255,255,255,0.2)),  url(${small_img})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                color: "#fff",
                width: '100%'
            }} className='panel-latest-articles__list-item'
            >
                {
                    date && languagePrismic.lang && (
                        <p className="p-tag date">
                            {date_by_origin}
                        </p>
                    )
                }
                <h5 className="h5 title">
                    {title}
                </h5>

                <h2 className="heading-main clickable link">
                    VIEW
                </h2>

            </div>
        </Anchor>
    );
};

LastArticleSmall.propTypes = {
    uid: PropTypes.string,
    title: PropTypes.string,
    small_img: PropTypes.string,
    short_description: PropTypes.array,
    date: PropTypes.string,
    alternative_text_image: PropTypes.string
};



// WEBPACK FOOTER //
// src/client/components/site/features/blogs/LastArticleSmall.js